<div class="preview_wrapper">
  <p class="title">Add Subcontractor
    <span class="green_circle_tick">
      <img src="../../../../assets/img/white_tick.svg" alt="">
    </span>
  </p>
  <div class="row">
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading"> Name</p>
        <p class="value">
          {{addSubcontractor?.name}}
        </p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading"> Email</p>
        <p class="value">
          {{addSubcontractor?.email}}
        </p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading"> Phone Number </p>
        <p class="value">
          {{addSubcontractor?.phone}}
        </p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading"> Alternate Phone </p>
        <p class="value">
          {{addSubcontractor?.alternate_phone}}
        </p>
      </div>
    </div>
  </div>
</div>

<!-- subcontractor detail start -->
<div class="preview_wrapper">
  <p class="title">Subcontractor Detail
    <span class="green_circle_tick">
      <img src="../../../../assets/img/white_tick.svg" alt="">
    </span>
  </p>
  <div class="row">
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Tax Number</p>
        <p class="value">{{subcontractorDetail?.tax_number}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Fax Number</p>
        <p class="value">{{subcontractorDetail?.fax}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Website URL</p>
        <p class="value">{{subcontractorDetail?.website ? 'https://' + subcontractorDetail?.website : ''}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Address Line 1</p>
        <p class="value">{{subcontractorDetail?.address?.address_line_1}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Address Line 2</p>
        <p class="value">{{subcontractorDetail?.address?.address_line_2}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">City</p>
        <p class="value"> {{subcontractorDetail?.address?.city}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">State</p>
        <p class="value"> {{subcontractorDetail?.address?.state_id?.name}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Zipcode</p>
        <p class="value"> {{subcontractorDetail?.address?.zipcode}}</p>
      </div>
    </div>

    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Misc Notes</p>
        <p class="value">{{subcontractorDetail?.misc_notes}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Notes</p>
        <p class="value">{{subcontractorDetail?.specific_notes}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Has Vehicle</p>
        <p class="value">{{subcontractorDetail?.has_vehicle ? 'Yes' : 'No'}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Can work in state</p>
        <p class="value">{{subcontractorDetail?.can_work_in_state  ? 'Yes' : 'No'}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Can work out state</p>
        <p class="value">{{subcontractorDetail?.can_work_out_state  ? 'Yes' : 'No'}}</p>
      </div>
    </div>
    @if (subcontractorDetail?.can_work_out_state) {
      <div class="col-md-6">
        <div class="wrap">
          <p class="heading">States</p>
          <p class="value">{{subcontractorDetail?.states ? coreService.arrayObjectToString(subcontractorDetail?.states):''}}</p>
        </div>
      </div>
    }

  </div>
</div>

<!-- subcontractor detail Billing Address -->
<div class="preview_wrapper">
  <p class="title">Billing Address
    <span class="green_circle_tick">
      <img src="../../../../assets/img/white_tick.svg" alt="">
    </span>
  </p>
  <div class="row">
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Address Line 1</p>
        <p class="value">{{subcontractorDetail?.billing_address?.address_line_1}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Address Line 2</p>
        <p class="value">{{subcontractorDetail?.billing_address?.address_line_2}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">City</p>
        <p class="value">{{subcontractorDetail?.billing_address?.city}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">State</p>
        <p class="value">{{subcontractorDetail?.billing_address?.state_id?.name}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Zip Code</p>
        <p class="value">{{subcontractorDetail?.billing_address?.zipcode}}</p>
      </div>
    </div>
  </div>
</div>

<!-- subcontractor Shipping Address -->
<div class="preview_wrapper">
  <p class="title">Shipping Address
    <span class="green_circle_tick">
      <img src="../../../../assets/img/white_tick.svg" alt="">
    </span>
  </p>
  <div class="row">
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Address Line  1</p>
        <p class="value">{{subcontractorDetail?.shipping_address?.address_line_1}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Address Line 2</p>
        <p class="value">{{subcontractorDetail?.shipping_address?.address_line_2}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">City</p>
        <p class="value">{{subcontractorDetail?.shipping_address?.city}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">State</p>
        <p class="value">{{subcontractorDetail?.shipping_address?.state_id?.name}}</p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="wrap">
        <p class="heading">Zip Code</p>
        <p class="value">{{subcontractorDetail?.shipping_address?.zipcode}}</p>
      </div>
    </div>
  </div>
</div>

<!-- subcontractor detail end -->

<!-- subcontractor contact -->
@if (!model) {
  <div class="preview_wrapper d-none">
    <p class="title">Subcontractor Contact
      <span class="green_circle_tick">
        <img src="../../../../assets/img/white_tick.svg" alt="">
      </span>
    </p>
    <div class="row">
      <div class="col-md-6">
        <div class="wrap">
          <p class="heading">First Name</p>
          <p class="value">{{subcontractorContact?.first_name}}</p>
        </div>
      </div>
      <div class="col-md-6">
        <div class="wrap">
          <p class="heading">Last Name</p>
          <p class="value">{{subcontractorContact?.last_name}}</p>
        </div>
      </div>
      <div class="col-md-6">
        <div class="wrap">
          <p class="heading">Email </p>
          <p class="value">{{subcontractorContact?.email}}</p>
        </div>
      </div>
      <div class="col-md-6">
        <div class="wrap">
          <p class="heading">Phone Number</p>
          <p class="value">{{subcontractorContact?.phone}}</p>
        </div>
      </div>
      <div class="col-12">
        <div class="wrap">
          <p class="heading">Cell Phone Number</p>
          <p class="value">{{subcontractorContact?.mobile}}</p>
        </div>
      </div>
      <!--<div class="col-md-6">
      <div class="wrap">
        <p class="heading">Contact Type</p>
        <p class="value">{{vendorContact?.username}}</p>
      </div>
    </div>-->
    <div class="col-12">
      <div class="wrap">
        <p class="heading">Notes</p>
        <p class="value">{{subcontractorContact?.notes}}</p>
      </div>
    </div>
  </div>
</div>
}

<!-- subcontractor certificates -->
<div class="preview_wrapper">
  <p class="title">Subcontractor Certificates
    <span class="green_circle_tick">
      <img src="../../../../assets/img/white_tick.svg" alt="">
    </span>
  </p>

  @for (certificate of subcontractorCertificates?.certificates; track certificate) {
    <div class="row">
      @if (certificate.is_certified) {
        <div class="col-6" >
          <div class="wrap">
            <p class="heading">Certificate Title</p>
            <p class="value">{{certificate?.name}}</p>
          </div>
        </div>
        <div class="col-6">
          <div class="wrap">
            <p class="heading">Expiration Date</p>
            <p class="value">{{certificate?.expiration_date | date}}</p>
          </div>
        </div>
      }
    </div>
  }

</div>
<!-- Notes section -->
<div class="preview_wrapper">
  <p class="title">Notes
    @if (subcontractorDetail?.misc_notes) {
      <span class="green_circle_tick">
        <img src="../../../../assets/img/white_tick.svg" alt="">
      </span>
    }
  </p>
  <div class="row">


    <div class="col-md-12">
      <div class="wrap">
        <p class="heading">Misc Note</p>
        <p class="value">{{subcontractorDetail?.misc_notes}}</p>
      </div>
    </div>
    <div class="col-md-12">
      <div class="wrap">
        <p class="heading">Notes</p>
        <p class="value">{{subcontractorDetail?.specific_notes}}</p>
      </div>
    </div>

  </div>
</div>

<!-- subcontractor add covered areas -->

<div class="preview_wrapper">
  <p class="title">Add Covered Areas
    <span class="green_circle_tick">
      <img src="../../../../assets/img/white_tick.svg" alt="">
    </span>
  </p>
  <div class="row">
    @for (state of addCoveredAreas?.covered_areas; track state) {
      <div class="col-md-12">
        <div class="wrap">
          <p class="heading">{{state?.state_name}}</p>
          <p class="value">
            <mat-chip-listbox>
              @for (area of state?.covered_areas; track area) {
                <mat-chip-option>{{area}}</mat-chip-option>
              }
            </mat-chip-listbox>
            <!--          {{coreService.arrayObjectToString(addCoveredAreas?.states)}}-->
          </p>
        </div>
      </div>
    }
    <!--    <div class="col-md-6">-->
    <!--      <div class="wrap">-->
    <!--        <p class="heading">Covered Areas</p>-->
    <!--        <p class="value">-->
    <!--          {{addCoveredAreas?.covered_areas}}-->
  <!--        </p>-->
<!--      </div>-->
<!--    </div>-->
</div>
</div>
